import React from "react";
import { ItemGrid, StyledMainGrid } from "./styled";
import Team from "./Team";
import BarrierControl from "./BarrierControl";
import GeneralDetails from "./GeneralDetails";
import WorkingHours from "./WorkingHours";

function LocationAdministration() {
    return (
        <>
            <StyledMainGrid
                container
                columns={12}
                rowSpacing={2}
                columnSpacing={2}
            >
                <ItemGrid size={{ xs: 12, md: 8 }}>
                    <GeneralDetails />
                </ItemGrid>
                <ItemGrid size={{ xs: 12, md: 4 }}>
                    <Team />
                </ItemGrid>
                <ItemGrid size={{ xs: 12, md: 8 }}>
                    <WorkingHours />
                </ItemGrid>
                <ItemGrid size={{ xs: 12, md: 4 }}>
                    <BarrierControl />
                </ItemGrid>
            </StyledMainGrid>
        </>
    );
}

export default LocationAdministration;
